import { __extends, __decorate } from 'tslib';
import { Component, Vue } from 'vue-property-decorator';
import { MountingPortal } from 'portal-vue';

/**
 * Портал для модального окна. Добавляет элемент модального окно к `body`.
 *
 * В обычной ситуации создаётся автоматически при использовании HseModal, ручное использование не требуется.
 */
var HseModalPortal = /** @class */ (function (_super) {
    __extends(HseModalPortal, _super);
    function HseModalPortal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HseModalPortal = __decorate([
        Component({
            name: 'HseModalPortal',
            components: {
                MountingPortal: MountingPortal
            }
        })
    ], HseModalPortal);
    return HseModalPortal;
}(Vue));

export default HseModalPortal;
